export default __webpack_public_path__ + "static/media/photo.3fa2b524.svg";